// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__1usLb","consentsList":"PatientConsents_consentsList__1IYQG","consentsListEmpty":"PatientConsents_consentsListEmpty__23b7G"};